import {Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges} from '@angular/core';
import {UiWidget} from '@pt/pt-models';
import {FormControl, FormGroup} from '@angular/forms';
import {WidgetRadiobuttonPreviewV0Dto} from './models/widget-radiobutton-preview-v0.dto';
// noinspection ES6PreferShortImport
import {ValidatorGenerator} from '../../../utils';
import {WidgetViewMode} from "../../../widget-internal-status";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'pt-widget-radiobutton-v0-radio',
  template: `
    <div class='radio-button-form-v0' *ngIf="widget && radioButtons && formGroup">
      <form [formGroup]='formGroup'
            class="position-relative d-flex">
        <div class='form-check radio-button-form-check me-3 mb-2'
             *ngFor='let radioButton of radioButtons'>
          <input class='form-check-input'
                 type='radio'
                 formControlName='value'
                 [value]='radioButton.uuid'
                 [id]="widget.internalId + '_radio_' + radioButton.uuid"
                 value='option1'>
          <label class='form-check-label'
                 [htmlFor]="widget.internalId + '_radio_' + radioButton.uuid">
            {{ radioButton.label }}
            <pt-w-help [help]='radioButton?.help'></pt-w-help>
          </label>
        </div>
      </form>
    </div>
  `,
  styles: [`
    .radio-button-form-v0 {
      margin: 8px 25px;
    }

    .radio-button-form-check {
      width: 30%;
      display: flex;
      padding: 0 10px;
      min-height: 24px;
      margin-bottom: 1px;
      align-items: center;
    }

    .radio-button-form-check:hover {
      background: #D6E4FF !important;
    }

    .radio-button-form-check input {
      margin: 0;
      cursor: pointer;
    }

    .radio-button-form-check .form-check-label {
      margin-left: 8px;
      cursor: pointer;
      width: 100%;
    }
  `]
})
export class WidgetRadiobuttonV0RadioComponent implements OnChanges, OnDestroy {
  @Input() widget: UiWidget;
  @Input() radioButtons: WidgetRadiobuttonPreviewV0Dto[];
  @Input() viewMode: WidgetViewMode;
  @Input() isLoading = false;

  @Output() valueChange = new EventEmitter<string>();
  public formGroup: FormGroup;
  private destroy$ = new Subject();

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.widget && this.radioButtons?.length > 0) {
      this.initFormGroupIfNull();
    }
  }

  private initFormGroupIfNull() {
    this.destroy$.next(true);
    const formGroupValidators = ValidatorGenerator.generateFromGroupValidator(this.widget?.validators);
    const validators = ValidatorGenerator.generateValidator(this.widget?.validators);
    const asyncValidators = ValidatorGenerator.generateAsyncValidator(this.widget?.validators);
    this.formGroup = new FormGroup({
      value: new FormControl(this.widget.value, validators, asyncValidators)
    }, {validators: formGroupValidators});

    if (this.viewMode && this.viewMode === 'PREVIEW' || this.viewMode === 'LOADING' || this.isLoading) {
      this.formGroup.disable();
    } else {
      this.formGroup.enable();
    }

    this.formGroup.valueChanges.pipe(
      takeUntil(this.destroy$)
    ).subscribe((value) => {
      this.valueChange.emit(value.value);
    })
  }
}




